import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { TabakOpties } from '@common/customControls/bariatrics';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';
import type { BariPreSecretarialAssistantMedScreeningReportDataV2 } from './bariPreSecretarialAssistantMedScreeningReportDataV2';
import {
    bariPreSecretarialAssistantMedScreeningReportBaseDraft,
    bariPreSecretarialAssistantMedScreeningReportBaseFinal,
} from '../bariPreSecretarialAssistantMedScreeningReportSchema';

const bariPreSecretarialAssistantMedScreeningReportFinal: TypedSchema<BariPreSecretarialAssistantMedScreeningReportDataV2> =
    {
        ...bariPreSecretarialAssistantMedScreeningReportBaseFinal,
        tabak_gebruik: Koi.koi().enum(TabakOpties),
        tabak_toelichting: getTextAreaStringSchema(true),
    };

const bariPreSecretarialAssistantMedScreeningReportDraft: TypedSchema<BariPreSecretarialAssistantMedScreeningReportDataV2> =
    {
        ...addAllowNull(bariPreSecretarialAssistantMedScreeningReportFinal),
        ...bariPreSecretarialAssistantMedScreeningReportBaseDraft,
    };

export const bariPreSecretarialAssistantMedScreeningReportDraftSchemaV2 = Koi.object(
    bariPreSecretarialAssistantMedScreeningReportDraft
);
export const bariPreSecretarialAssistantMedScreeningReportFinalSchemaV2 = Koi.object(
    bariPreSecretarialAssistantMedScreeningReportFinal
);
